var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('slice-contact-form');
import { breakpoints, theme } from '@shapeable/theme';
import { useEntity } from '../../hooks/use-entity';
import { useLang } from '../../hooks/use-lang';
import { ExpandButton } from '../elements/expand-button';
import { ContentEntityContent } from './content-entity-content';
import { ContactForm } from '../elements/contact-form';
import AnimateHeight from 'react-animate-height';
export var SliceContactFormDefaultProps = {
  variant: 'reveal'
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-bottom ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-bottom ", ";\n  "])), theme.UNIT(20))
});
var BodyStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n  "])))
});
var ContentStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    max-width: 700px;\n    width: 100%;\n  "], ["\n    max-width: 700px;\n    width: 100%;\n  "])))
});
var ButtonStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "], ["\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "])), theme.UNIT(8), theme.UNIT(8))
});
var FormStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    width: 100%;\n    box-sizing: border-box;\n    margin-top: ", ";\n    max-width: 700px;\n  "], ["\n    width: 100%;\n    box-sizing: border-box;\n    margin-top: ", ";\n    max-width: 700px;\n  "])), theme.UNIT(10))
});
var FormRevealStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    overflow: hidden;\n    transition: height 0.3s;\n  "], ["\n    overflow: hidden;\n    transition: height 0.3s;\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Content: styled(ContentEntityContent)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Button: styled(ExpandButton)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  FormReveal: styled.div.attrs(cls.attr('form-reveal'))(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), FormRevealStyles),
  Form: styled(ContactForm)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), FormStyles)
};
export var SliceContactForm = function SliceContactForm(props) {
  var className = props.className,
      children = props.children,
      variant = props.variant,
      contactFormProps = __rest(props, ["className", "children", "variant"]);

  var entity = useEntity(props.entity);

  var _a = __read(useState(false), 2),
      isExpanded = _a[0],
      setIsExpanded = _a[1];

  var t = useLang();
  var Form = props.formComponent || My.Form;
  return React.createElement(My.Container, {
    className: className
  }, React.createElement(My.Body, null, variant === 'reveal' ? React.createElement(React.Fragment, null, React.createElement(My.Button, {
    isExpanded: isExpanded,
    color: "primary",
    onClick: function onClick() {
      setIsExpanded(!isExpanded);
    },
    label: t('Show Contact Form'),
    expandedLabel: t('Hide Contact Form')
  }), React.createElement(AnimateHeight, {
    height: isExpanded ? 'auto' : 0
  }, React.createElement(Form, __assign({}, contactFormProps)))) : React.createElement(Form, __assign({}, contactFormProps)), children));
};
SliceContactForm.defaultProps = SliceContactFormDefaultProps;
SliceContactForm.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;